import axios, {AxiosInstance} from "axios";
import store from "@/store";
import router from "@/router";

const ENV = process.env.NODE_ENV;
export const API_URL = process.env.VUE_APP_API_BASE_URL;

export const APICONFIG = {
  baseURL: API_URL + "/api" as string,
  baseLoginURL: API_URL as string,
};

class auth {
  public authRequest: AxiosInstance; // request avec interceptor (à utiliser partout)
  public apiRequest: AxiosInstance; // request sans interceptor (pour login uniquement)

  constructor() {
    this.authRequest = axios.create({
      baseURL: APICONFIG.baseURL,
      withCredentials: true,
    });
    this.apiRequest = axios.create({
      baseURL: APICONFIG.baseLoginURL,
      withCredentials: true,
    });

    this.initInterceptor();
  }

  initInterceptor() {
    this.authRequest.interceptors.response.use((response) => {
      return Promise.resolve(response.data);
    }, (error: any) => {
      this.handleStatus(error);
      return Promise.reject(error);
    });
  }

  handleStatus(error: any) {
    const status = error.response.status;
    console.log('ERREUR INTERCEPTOR', status);
    switch (status) {
      case 401:
        store.dispatch('logout');
        router.push({name: 'Login'});
        break;
    }
  }
}

const apiService = new auth();

export default apiService;
